import React, { Component } from "react";
import { Form, Button, Col, Row, Icon, Tooltip, Drawer, Modal, message, Divider, DatePicker, Table, Select, Tag, Alert } from "antd";
import axios from "axios";
import Colors from '../utils/Colors';
import InputForm from "./InputForm";
import { getUsuario } from "../utils/LoginManager";
import moment from "moment-timezone";

const { Item: ItemForm } = Form;
const TIPOS_HISTORICO = [
    { key: 'NOVAS', label: 'Novas cobranças', color: 'blue' },
    { key: 'ANTES', label: 'Antes do vencimento', color: 'cyan' },
    { key: 'NODIA', label: 'No vencimento', color: 'orange' },
    { key: 'RELEM', label: 'Lembrete de vencidas', color: 'purple' },
    { key: 'PAGO', label: 'Pagamento confirmado', color: 'green' },
    { key: 'ERROS', label: 'Erro no envio', color: 'red' },
];

export const OPCOES_COMBO_DIAS_ANTES = [
    { key: '5', label: '5 dias' },
    { key: '10', label: '10 dias' },
    { key: '15', label: '15 dias' },
    { key: '30', label: '30 dias' },
]

export const OPCOES_COMBO_DIAS_APOS = [
    { key: '1', label: '1 dia' },
    { key: '3', label: '3 dias' },
    { key: '7', label: '7 dias' },
    { key: '10', label: '15 dias' },
    { key: '30', label: '30 dias' },
]


class ParametrosCobrancasForm extends Component {
    state = {
        salvando: false,
        historico: [],
        historicoCarregando: false,
        historicoErro: '',
        historicoPeriodo: [moment().startOf('month'), moment().endOf('day')],
        historicoTipo: undefined,
        historicoPagina: 1,
        historicoLimite: 20,
        historicoTotal: 0,

        registro: {
            pcobr_nova_wa: false,
            pcobr_nova_email: false,
            pcobr_dias_antes: { key: '5' },
            pcobr_dias_antes_wa: false,
            pcobr_dias_antes_email: false,
            pcobr_dia_venc_wa: false,
            pcobr_dia_venc_email: false,
            pcobr_dias_vencido: { key: '7' },
            pcobr_dias_vencido_wa: false,
            pcobr_dias_vencido_email: false,
            pcobr_pago_wa: false,
            pcobr_pago_email: false,
            pcobr_data_inicio: moment().format('DD/MM/YYYY'),

            planoCtasReceitasSelect: [],
            planoCtasDespesasSelect: [],
            ctasReceitasSelect: [],
            ctasDespesasSelect: [],
        },
    }


    componentDidMount() {
        const usuario = getUsuario();
        this.buscaPlanoCtasReceitas();
        this.buscaPlanoCtasDespesas();
        this.setState({
            usuario,
        }, () => {
            this.onBuscaParametros();
            this.buscarHistorico(1);
        });
    }



    componentWillUnmount() {
        this.historicoDesmontado = true;
        if (this.historicoCancel) this.historicoCancel.cancel();
    }

    buscarHistorico = (pagina = 1, limite = this.state.historicoLimite) => {
        const { historicoPeriodo, historicoTipo } = this.state;
        if (this.historicoCancel) this.historicoCancel.cancel();
        const requisicao = (this.historicoRequisicao || 0) + 1;
        this.historicoRequisicao = requisicao;
        this.historicoCancel = axios.CancelToken.source();
        this.setState({ historicoCarregando: true, historicoErro: '', historicoPagina: pagina, historicoLimite: limite });
        axios.get('/titulos/historicoCobrancas', {
            cancelToken: this.historicoCancel.token,
            params: {
                page: pagina,
                limite,
                tipo: historicoTipo || undefined,
                data_ini: historicoPeriodo && historicoPeriodo[0] ? historicoPeriodo[0].format('YYYY-MM-DD') : undefined,
                data_fim: historicoPeriodo && historicoPeriodo[1] ? historicoPeriodo[1].format('YYYY-MM-DD') : undefined,
            },
        }).then(response => {
            if (this.historicoDesmontado || requisicao !== this.historicoRequisicao) return;
            const dados = response.data;
            this.setState({
                historico: dados.data || [],
                historicoTotal: Number(dados.total) || 0,
                historicoPagina: Number(dados.current_page) || pagina,
                historicoCarregando: false,
            });
        }).catch(error => {
            if (this.historicoDesmontado || requisicao !== this.historicoRequisicao || axios.isCancel(error)) return;
            this.setState({
                historico: [], historicoTotal: 0, historicoCarregando: false,
                historicoErro: 'Não foi possível carregar o histórico de cobranças. Verifique a conexão e clique em Atualizar.',
            });
        });
    }

    limparFiltrosHistorico = () => {
        this.setState({ historicoPeriodo: [], historicoTipo: undefined }, () => this.buscarHistorico(1));
    }

    renderHistorico = () => {
        const { historico, historicoCarregando, historicoErro, historicoPeriodo,
            historicoTipo, historicoPagina, historicoLimite, historicoTotal } = this.state;
        const colunas = [
            { title: 'Data e hora', dataIndex: 'hcobr_data', width: 170,
                render: valor => valor && moment(valor).isValid() ? moment(valor).format('DD/MM/YYYY HH:mm:ss') : '—' },
            { title: 'Título (ID)', dataIndex: 'hcobr_idf_tit', width: 110 },
            { title: 'Parcela', dataIndex: 'hcobr_parcela', width: 90 },
            { title: 'Tipo', dataIndex: 'hcobr_tipo', width: 210, render: valor => {
                const tipo = TIPOS_HISTORICO.find(item => item.key === valor);
                return <Tag color={tipo ? tipo.color : undefined}>{tipo ? tipo.label : (valor || '—')}</Tag>;
            } },
            { title: 'Descrição / resultado', dataIndex: 'hcobr_descricao',
                render: valor => valor || '—' },
        ];
        return (
            <div style={{ marginTop: 24, marginBottom: 24 }}>
                <span className="tituloPage">Histórico dos envios de cobranças</span>
                <div className="divider-page1" />
                <p style={{ marginTop: 12, color: '#666' }}>
                    Registros de envios e tentativas. Consulte a descrição para verificar o resultado.
                </p>
                <Row gutter={16} style={{ marginBottom: 16 }}>
                    <Col xs={24} md={10} style={{ marginBottom: 12 }}>
                        <div>Período do histórico</div>
                        <DatePicker.RangePicker value={historicoPeriodo} format="DD/MM/YYYY"
                            style={{ width: '100%' }} allowClear
                            onChange={valor => this.setState({ historicoPeriodo: valor || [] }, () => this.buscarHistorico(1))} />
                    </Col>
                    <Col xs={24} md={7} style={{ marginBottom: 12 }}>
                        <div>Tipo de cobrança</div>
                        <Select value={historicoTipo} allowClear placeholder="Todos os tipos" style={{ width: '100%' }}
                            onChange={valor => this.setState({ historicoTipo: valor }, () => this.buscarHistorico(1))}>
                            {TIPOS_HISTORICO.map(tipo => <Select.Option key={tipo.key} value={tipo.key}>{tipo.label}</Select.Option>)}
                        </Select>
                    </Col>
                    <Col xs={24} md={7} style={{ marginTop: 20, marginBottom: 12 }}>
                        <Button htmlType="button" icon="reload" loading={historicoCarregando}
                            onClick={() => this.buscarHistorico(1)} style={{ marginRight: 8 }}>Atualizar</Button>
                        <Button htmlType="button" onClick={this.limparFiltrosHistorico}>Limpar filtros</Button>
                    </Col>
                </Row>
                {historicoErro && <Alert type="error" showIcon message={historicoErro} style={{ marginBottom: 16 }} />}
                <Table rowKey="hcobr_idf" size="small" columns={colunas} dataSource={historico}
                    loading={historicoCarregando} scroll={{ x: 950 }}
                    locale={{ emptyText: historicoErro ? 'Histórico indisponível' : 'Nenhum registro encontrado para os filtros informados.' }}
                    pagination={{
                        current: historicoPagina, pageSize: historicoLimite, total: historicoTotal,
                        showSizeChanger: true, pageSizeOptions: ['20', '50', '100'],
                        showTotal: total => `${total} registro(s)`,
                    }}
                    onChange={paginacao => this.buscarHistorico(
                        paginacao.pageSize !== historicoLimite ? 1 : paginacao.current, paginacao.pageSize
                    )} />
            </div>
        );
    }

    onSalvarClick = () => {
        if ((!this.state.registro.pcobr_data_inicio) || (!moment(this.state.registro.pcobr_data_inicio, 'DD/MM/YYYY', true).isValid())) {
            Modal.warning({ title: 'Aviso!', content: 'Informe uma Data Válida' });
            return;
        }

        if ((this.state.registro.pcobr_dias_antes_wa) || (this.state.registro.pcobr_dias_antes_email)) {
            if ((!this.state.registro.pcobr_dias_antes) || (this.state.registro.pcobr_dias_antes.key === '0') || (this.state.registro.pcobr_dias_antes.key === '')) {
                Modal.warning({ title: 'Aviso!', content: 'Informe quantos dias para o aviso' });
                return;
            }
        }
        if ((this.state.registro.pcobr_dias_vencido_wa) || (this.state.registro.pcobr_dias_vencido_email)) {
            if ((!this.state.registro.pcobr_dias_vencido) || (this.state.registro.pcobr_dias_vencido.key === '0') || (this.state.registro.pcobr_dias_vencido.key === '')) {
                Modal.warning({ title: 'Aviso!', content: 'Informe quantos dias para o aviso' });
                return;
            }
        }

        this.setState({ salvando: true })

        const registro = {
            pcobr_nova_wa: this.state.registro.pcobr_nova_wa ? 1 : 0,
            pcobr_nova_email: this.state.registro.pcobr_nova_email ? 1 : 0,
            pcobr_dias_antes_wa: this.state.registro.pcobr_dias_antes_wa ? this.state.registro.pcobr_dias_antes.key : 0,
            pcobr_dias_antes_email: this.state.registro.pcobr_dias_antes_email ? this.state.registro.pcobr_dias_antes.key : 0,
            pcobr_dia_venc_wa: this.state.registro.pcobr_dia_venc_wa ? 1 : 0,
            pcobr_dia_venc_email: this.state.registro.pcobr_dia_venc_email ? 1 : 0,
            pcobr_dias_vencido_wa: this.state.registro.pcobr_dias_vencido_wa ? this.state.registro.pcobr_dias_vencido.key : 0,
            pcobr_dias_vencido_email: this.state.registro.pcobr_dias_vencido_email ? this.state.registro.pcobr_dias_vencido.key : 0,
            pcobr_pago_wa: this.state.registro.pcobr_pago_wa ? 1 : 0,
            pcobr_pago_email: this.state.registro.pcobr_pago_email ? 1 : 0,
            pcobr_data_inicio: moment(this.state.registro.pcobr_data_inicio, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            listaReceitas: this.state.ctasReceitasSelect,
            listaDespesas: this.state.ctasDespesasSelect,
        };

        axios.put('/parametros/updateCobranca', registro)
            .then(response => {
                message.success('Parâmetros gravados com sucesso');
                this.setState({ salvando: false })
            })
            .catch(error => {
                console.error(error.response);
                this.setState({ salvando: false })
                Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
            })
    }


    onBuscaParametros = registro => {
        this.setState({ carregando: true });
        axios.get(`/parametros/parametros_cobranca`)
            .then(response => {
                const { dados } = response.data;

                // console.log('onBuscaParametros: ', response.data);

                if (dados.pcobr_dias_antes_wa) {
                    dados.pcobr_dias_antes = {
                        key: String(dados.pcobr_dias_antes_wa),
                        label: "",
                    }
                } else if (dados.pcobr_dias_antes_email) {
                    dados.pcobr_dias_antes = {
                        key: String(dados.pcobr_dias_antes_email),
                        label: "",
                    }
                } else {
                    dados.pcobr_dias_antes = {
                        key: "5",
                        label: "",
                    }
                }

                if (dados.pcobr_dias_vencido_wa) {
                    dados.pcobr_dias_vencido = {
                        key: String(dados.pcobr_dias_vencido_wa),
                        label: "",
                    }
                } else if (dados.pcobr_dias_vencido_email) {
                    dados.pcobr_dias_vencido = {
                        key: String(dados.pcobr_dias_vencido_email),
                        label: "",
                    }
                } else {
                    dados.pcobr_dias_vencido = {
                        key: "7",
                        label: "",
                    }
                }

                dados.pcobr_data_inicio = moment(dados.pcobr_data_inicio, 'YYYY-MM-DD').format('DD/MM/YYYY');

                const ctasReceitasSelect = response.data.ctasReceitas.map(regList => {
                    return {
                        key: regList.pccr_plano_contas,
                        label: regList.pc_descricao + ' [' + regList.pc_conta + ']',
                    }
                });

                const ctasDespesasSelect = response.data.ctasDespesas.map(regList => {
                    return {
                        key: regList.pccr_plano_contas,
                        label: regList.pc_descricao + ' [' + regList.pc_conta + ']',
                    }
                });


                this.setState({
                    registro: dados,
                    ctasReceitasSelect,
                    ctasDespesasSelect,
                    carregando: false,
                })
            })
            .catch(error => {
                console.error(error.response);
                this.setState({
                    carregando: false,
                })
            })
    };


    buscaPlanoCtasReceitas = async () => {
        this.setState({ planoCtasReceitasSelect: [] });
        return await axios.get('/planoContas/lista', {
            params: {
                tipo: 'E'
            }
        })
            .then(response => {
                const planoCtasReceitasSelect = response.data.map(regList => {
                    return {
                        key: regList.pc_idf,
                        label: regList.pc_descricao + ' [' + regList.pc_conta + ']',
                    }
                });
                this.setState({
                    planoCtasReceitasSelect,
                })
            }).catch(error => {
                console.error(error.response);
            })
    }

    buscaPlanoCtasDespesas = async () => {
        this.setState({ planoCtasDespesasSelect: [] });
        return await axios.get('/planoContas/lista', {
            params: {
                tipo: 'S'
            }
        })
            .then(response => {
                const planoCtasDespesasSelect = response.data.map(regList => {
                    return {
                        key: regList.pc_idf,
                        label: regList.pc_descricao + ' [' + regList.pc_conta + ']',
                    }
                });
                this.setState({
                    planoCtasDespesasSelect,
                })
            }).catch(error => {
                console.error(error.response);
            })
    }



    onChange = event => {
        const value = event.target.value;
        const id = event.target.id;
        const { registro } = this.state;
        registro[id] = value;
        this.setState({ [id]: value });
    };

    onDateChange = event => {
        const { registro } = this.state;
        registro['pcobr_data_inicio'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
        this.setState({ pcobr_data_inicio: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
    }





    render() {
        const { salvando, carregando } = this.state;
        const { pcobr_nova_wa, pcobr_nova_email, pcobr_dias_antes, pcobr_dias_antes_wa, pcobr_dias_antes_email, pcobr_dia_venc_wa, pcobr_dia_venc_email,
            pcobr_dias_vencido, pcobr_dias_vencido_wa, pcobr_dias_vencido_email, pcobr_pago_wa, pcobr_pago_email, pcobr_data_inicio,
        } = this.state.registro;
        const { planoCtasReceitasSelect, planoCtasDespesasSelect, ctasReceitasSelect, ctasDespesasSelect } = this.state;

        // console.log('ParametrosCobrancasForm.state: ', this.state);

        return (
            <div>
                <span className="tituloPage">Parâmetros para Cobrança</span>
                <div className="divider-page1" />

                <div style={{ marginTop: 30 }}>
                    <Row>

                        <Col xs={24} sm={6} >
                            <span>Data Início do Envio de Cobranças</span>
                            <DatePicker
                                onChange={this.onDateChange}
                                format="DD/MM/YYYY"
                                showToday={true}
                                allowClear={false}
                                value={moment(pcobr_data_inicio, "DD/MM/YYYY", true)}
                                style={{ width: "100%" }}
                            />
                        </Col>

                        <Col xs={24} sm={24} style={{ marginTop: 20 }}>
                            <span>Plano de Contas para Receitas</span>
                            <InputForm
                                type="select"
                                id="ctasReceitasSelect"
                                ref="ctasReceitasSelect"
                                value={ctasReceitasSelect}
                                placeholder="Selecione os Planos de Contas para Receitas"
                                onChange={this.onChange}
                                data={planoCtasReceitasSelect}
                                style={{ width: "100%" }}
                                multiple
                            />
                        </Col>

                        <Col xs={24} sm={24} style={{ marginTop: -10 }}>
                            <span>Plano de Contas para Despesas</span>
                            <InputForm
                                type="select"
                                id="ctasDespesasSelect"
                                ref="ctasDespesasSelect"
                                value={ctasDespesasSelect}
                                placeholder="Selecione os Planos de Contas para Despesas"
                                onChange={this.onChange}
                                data={planoCtasDespesasSelect}
                                style={{ width: "100%" }}
                                multiple
                            />
                        </Col>


                        <Col xs={24} sm={8} style={{ marginTop: 0, marginBottom: 0 }}>
                            <span>Avisar ciação de novas cobranças à Pagar</span>
                        </Col>
                        <Col xs={24} sm={2} style={{ marginTop: -10, marginBottom: -10 }}>
                            <InputForm
                                type="checkbox"
                                id="pcobr_nova_wa"
                                ref="pcobr_nova_wa"
                                onChange={this.onChange}
                                value={pcobr_nova_wa ? true : false}
                            >
                                WhatsApp
                            </InputForm>
                        </Col>
                        <Col xs={24} sm={2} style={{ marginTop: -10, marginBottom: -10 }}>
                            <InputForm
                                type="checkbox"
                                id="pcobr_nova_email"
                                ref="pcobr_nova_email"
                                onChange={this.onChange}
                                value={pcobr_nova_email ? true : false}
                            >
                                Email
                            </InputForm>
                        </Col>

                        <Divider />

                        <Col xs={24} sm={6} style={{ marginTop: 0, marginBottom: 0 }}>
                            <span>Enviar cobranças antes do vencimento</span>
                        </Col>
                        <Col xs={2} style={{ marginTop: -10, paddingRight: 20 }}>
                            <InputForm
                                type="select"
                                id="pcobr_dias_antes"
                                ref="pcobr_dias_antes"
                                value={pcobr_dias_antes}
                                placeholder="Selecione"
                                onChange={this.onChange}
                                data={OPCOES_COMBO_DIAS_ANTES}
                                validator={value => Boolean(value)}
                                style={{ width: "100%" }}
                            />
                        </Col>
                        <Col xs={24} sm={2} style={{ marginTop: -10, marginBottom: -10 }}>
                            <InputForm
                                type="checkbox"
                                id="pcobr_dias_antes_wa"
                                ref="pcobr_dias_antes_wa"
                                onChange={this.onChange}
                                value={pcobr_dias_antes_wa ? true : false}
                            >
                                WhatsApp
                            </InputForm>
                        </Col>
                        <Col xs={24} sm={2} style={{ marginTop: -10, marginBottom: -10 }}>
                            <InputForm
                                type="checkbox"
                                id="pcobr_dias_antes_email"
                                ref="pcobr_dias_antes_email"
                                onChange={this.onChange}
                                value={pcobr_dias_antes_email ? true : false}
                            >
                                Email
                            </InputForm>
                        </Col>

                        <Divider />


                        <Col xs={24} sm={8} style={{ marginTop: 0, marginBottom: 0 }}>
                            <span>Enviar cobranças pendentes no dia do vencimento</span>
                        </Col>
                        <Col xs={24} sm={2} style={{ marginTop: -10, marginBottom: -10 }}>
                            <InputForm
                                type="checkbox"
                                id="pcobr_dia_venc_wa"
                                ref="pcobr_dia_venc_wa"
                                onChange={this.onChange}
                                value={pcobr_dia_venc_wa ? true : false}
                            >
                                WhatsApp
                            </InputForm>
                        </Col>
                        <Col xs={24} sm={2} style={{ marginTop: -10, marginBottom: -10 }}>
                            <InputForm
                                type="checkbox"
                                id="pcobr_dia_venc_email"
                                ref="pcobr_dia_venc_email"
                                onChange={this.onChange}
                                value={pcobr_dia_venc_email ? true : false}
                            >
                                Email
                            </InputForm>
                        </Col>

                        <Divider />

                        <Col xs={24} sm={6} style={{ marginTop: 0, marginBottom: 0 }}>
                            <span>Relembrar cobranças vencidas a cada após o vencimento</span>
                        </Col>
                        <Col xs={2} style={{ marginTop: -10, paddingRight: 20 }}>
                            <InputForm
                                type="select"
                                id="pcobr_dias_vencido"
                                ref="pcobr_dias_vencido"
                                value={pcobr_dias_vencido}
                                placeholder="Selecione"
                                onChange={this.onChange}
                                data={OPCOES_COMBO_DIAS_APOS}
                                validator={value => Boolean(value)}
                                style={{ width: "100%" }}
                            />
                        </Col>
                        <Col xs={24} sm={2} style={{ marginTop: -10, marginBottom: -10 }}>
                            <InputForm
                                type="checkbox"
                                id="pcobr_dias_vencido_wa"
                                ref="pcobr_dias_vencido_wa"
                                onChange={this.onChange}
                                value={pcobr_dias_vencido_wa ? true : false}
                            >
                                WhatsApp
                            </InputForm>
                        </Col>
                        <Col xs={24} sm={2} style={{ marginTop: -10, marginBottom: -10 }}>
                            <InputForm
                                type="checkbox"
                                id="pcobr_dias_vencido_email"
                                ref="pcobr_dias_vencido_email"
                                onChange={this.onChange}
                                value={pcobr_dias_vencido_email ? true : false}
                            >
                                Email
                            </InputForm>
                        </Col>

                        <Divider />

                        <Col xs={24} sm={8} style={{ marginTop: 0, marginBottom: 0 }}>
                            <span>Avisar quando os pagamentos forem confirmados</span>
                        </Col>
                        <Col xs={24} sm={2} style={{ marginTop: -10, marginBottom: -10 }}>
                            <InputForm
                                type="checkbox"
                                id="pcobr_pago_wa"
                                ref="pcobr_pago_wa"
                                onChange={this.onChange}
                                value={pcobr_pago_wa ? true : false}
                            >
                                WhatsApp
                            </InputForm>
                        </Col>
                        <Col xs={24} sm={2} style={{ marginTop: -10, marginBottom: -10 }}>
                            <InputForm
                                type="checkbox"
                                id="pcobr_pago_email"
                                ref="pcobr_pago_email"
                                onChange={this.onChange}
                                value={pcobr_pago_email ? true : false}
                            >
                                Email
                            </InputForm>
                        </Col>


                    </Row>
                </div>


                <div style={{ marginBottom: 50 }}>
                    <div className="divider-form" />
                    <ItemForm>
                        <Row>
                            <Col xs={24}>
                                <Button
                                    type="primary"
                                    htmlType="button"
                                    loading={salvando}
                                    onClick={this.onSalvarClick}
                                    className="btn-salvar"
                                >
                                    Salvar
                                </Button>
                            </Col>
                        </Row>
                    </ItemForm>
                </div>


                {this.renderHistorico()}
            </div >
        );
    }
}

export default ParametrosCobrancasForm;



// WEBPACK FOOTER //
// ./src/components/ParametrosCobrancasForm.js